/* Project Unity wellness-lab video blocks (.pu-labs__media). Loaded next to the
   markup by snippets/project-unity-labs-section.liquid and the inline lab blocks. */
(function () {
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mediaItems = Array.prototype.slice.call(document.querySelectorAll('.pu-labs__media'));

  mediaItems.forEach(function (media, index) {
    const video = media.querySelector('video[data-pu-labs-video], video');
    if (!video || media.dataset.puLabsVideoReady === 'true') return;

    media.dataset.puLabsVideoReady = 'true';
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    if (!video.id) video.id = 'pu-labs-video-' + (index + 1);
    /* The lab still is 60 KB and sits far below the fold: attach it as the block approaches
       (or immediately when markup already carries a poster, as on the business hero). */
    const posterSource = video.poster || video.dataset.poster || '';
    let posterApplied = false;
    const applyPoster = function () {
      if (posterApplied || !posterSource) return;
      posterApplied = true;
      if (!video.poster) video.poster = posterSource;
      media.style.backgroundImage = 'url(' + JSON.stringify(posterSource) + ')';
    };
    if (video.poster || typeof window.IntersectionObserver !== 'function') applyPoster();
    else {
      const posterObserver = new window.IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        posterObserver.disconnect();
        applyPoster();
      }, { rootMargin: '800px 0px' });
      posterObserver.observe(media);
    }

    let inView = false;
    let userPaused = false;
    let userPlayed = false;
    let failed = false;
    let playPending = false;

    const control = document.createElement('button');
    control.className = 'pu-labs__video-toggle';
    control.type = 'button';
    control.setAttribute('aria-controls', video.id);
    control.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path data-pu-video-play d="M7 5.2 15 10l-8 4.8Z" stroke="none"></path><g data-pu-video-pause><path d="M7 5v10M13 5v10" fill="none"></path></g></svg>';

    const fallback = document.createElement('p');
    fallback.className = 'pu-labs__video-fallback';
    fallback.setAttribute('role', 'status');
    fallback.hidden = true;
    fallback.textContent = 'Video unavailable. A still image of the Oxydise wellness lab is shown instead.';

    media.appendChild(fallback);
    media.appendChild(control);

    const updateControl = function () {
      const paused = video.paused;
      control.classList.toggle('is-paused', paused);
      control.setAttribute('aria-label', failed ? 'Retry wellness lab video' : paused ? 'Play wellness lab video' : 'Pause wellness lab video');
    };

    const showFallback = function () {
      applyPoster();
      failed = true;
      playPending = false;
      video.pause();
      fallback.hidden = false;
      media.classList.add('has-video-error');
      updateControl();
    };

    const shouldPlay = function () {
      return inView && !document.hidden && !userPaused && (!motionPreference.matches || userPlayed);
    };

    /* WebKit (iOS Safari) fires an error event on a <source> that has no src yet, so the
       deferred source must not carry a failure listener until its src is attached; otherwise
       the block shows the still-image fallback before the footage was ever requested. */
    let sourcesAttached = false;
    const attachSources = function () {
      applyPoster();
      let changed = false;
      video.querySelectorAll('source[data-src]').forEach(function (source) {
        if (!source.getAttribute('src')) {
          source.setAttribute('src', source.dataset.src);
          source.addEventListener('error', showFallback);
          changed = true;
        }
      });
      sourcesAttached = true;
      if (changed) video.load();
    };

    const playVideo = function () {
      if (failed || playPending || !shouldPlay()) return;
      attachSources();
      playPending = true;
      const playRequest = video.play();
      if (playRequest && typeof playRequest.then === 'function') {
        playRequest.then(function () {
          playPending = false;
          if (!shouldPlay()) video.pause();
          updateControl();
        }).catch(function () {
          playPending = false;
          if (video.error) showFallback();
          else updateControl();
        });
      } else {
        playPending = false;
        updateControl();
      }
    };

    control.addEventListener('click', function () {
      if (failed) {
        failed = false;
        fallback.hidden = true;
        media.classList.remove('has-video-error');
        video.load();
      } else if (!video.paused || playPending) {
        userPaused = true;
        userPlayed = false;
        video.pause();
        updateControl();
        return;
      }
      userPaused = false;
      userPlayed = true;
      inView = true;
      playVideo();
    });
    video.addEventListener('play', updateControl);
    video.addEventListener('pause', updateControl);
    video.addEventListener('error', function () {
      if (sourcesAttached && video.error) showFallback();
    });
    video.querySelectorAll('source').forEach(function (source) {
      if (source.getAttribute('src')) source.addEventListener('error', showFallback);
    });

    const visibilityChanged = function () {
      if (shouldPlay()) playVideo();
      else video.pause();
    };
    if (typeof window.IntersectionObserver === 'function') {
      const observer = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          visibilityChanged();
        });
      }, { threshold: 0 });
      observer.observe(media);
    } else {
      const updateVisibility = function () {
        const rect = media.getBoundingClientRect();
        inView = rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
        visibilityChanged();
      };
      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
      updateVisibility();
    }
    document.addEventListener('visibilitychange', visibilityChanged);
    const handleMotionChange = function (event) {
      if (event.matches) {
        userPlayed = false;
        video.pause();
      } else visibilityChanged();
    };
    if (typeof motionPreference.addEventListener === 'function') motionPreference.addEventListener('change', handleMotionChange);
    else if (typeof motionPreference.addListener === 'function') motionPreference.addListener(handleMotionChange);
    if (sourcesAttached && video.error) showFallback();
    updateControl();
  });
})();
